'use strict';

import checkboxTemplate from './checkbox.directive.html';

export default angular
  .module('maestro.directives.semantic.checkbox', [])

  .directive('smCheckbox', function() {
    return {
      restrict: 'E',
      template: checkboxTemplate,
      require: '?ngModel',
      transclude: true,
      replace: true,
      scope: {
        ngDisabled: '=',
        class: '@'
      },
      link: (scope, element, attrs, ngModel, transclude) => {
        element.checkbox();
        let checked = false;
        let disabled = false;
        let input = element.find('input');

        let trueVal = element.attr('true-value');
        let falseVal = element.attr('false-value');

        transclude(scope, nodes => {
          element.find('label').append(nodes);
        });

        if (!ngModel) {
          throw new Error('The \'smCheckbox\' directive requires a \'ng-model\' value');
        }

        $(element).on('click', toggleFn);

        ngModel.$render = () => {
          let val = ngModel.$viewValue;
          checked = trueVal ? val == trueVal : val;
          input.prop('checked', checked);
        };

        scope.$watch('ngDisabled', val => {
          disabled = val || false;
          input.attr('disabled', disabled);
        });

        if (attrs.ariaLabel === void 0) {
          element.attr('aria-label', element[0].textContent.trim());
        }

        function toggleFn() {
          scope.$applyAsync(() => {
            if (disabled) {
              return;
            }
            checked = !checked;
            if (checked) {
              ngModel.$setViewValue(trueVal || checked);
            } else {
              ngModel.$setViewValue(falseVal || checked);
            }
          });
        }
      }
    };
  })

  .name;
